"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IHealthAndWellness = void 0;
var IHealthAndWellness;
(function (IHealthAndWellness) {
    IHealthAndWellness["Decreasestress"] = "decreasestress";
    IHealthAndWellness["Gainmuscle"] = "gainmuscle";
    IHealthAndWellness["Healthconcerns"] = "healthconcerns";
    IHealthAndWellness["Increaseenergy"] = "increaseenergy";
    IHealthAndWellness["Other"] = "other";
})(IHealthAndWellness || (exports.IHealthAndWellness = IHealthAndWellness = {}));
//# sourceMappingURL=health-and-wellness.js.map